import React from 'react';

import { IResolvedNote } from '@/src/utils/collections/review.mapper';
import { ReviewCountry } from '@/src/components/review/ReviewDetailed/ReviewNote/ReviewCountry';
import { StarRating } from '@/src/components/star-rating/StarRating';

type IReviewNoteCellProps = {
  data: IResolvedNote;
};

export const ReviewNoteCell = ({ data }: IReviewNoteCellProps) => {
  return (
    <div
      className={
        'flex min-h-[360px] w-[280px] flex-none flex-col justify-between rounded-3xl bg-overlay p-8'
      }
    >
      <div>
        <StarRating rating={data.note} size={17} />
        <div className={'mt-0.5'}>
          <p className={'text-sm'}>{data.date}</p>
          <div className={'mt-5 space-y-1'}>
            <p className={'text-xl font-semibold'}>{data.title}</p>
            <p className={'font-semibold leading-4 text-gray'}>
              {data.comment}
            </p>
            <p className={'text-gray'}>{data.signature}</p>
          </div>
        </div>
      </div>

      <ReviewCountry
        countryStart={data.countryStart}
        countryEnd={data.countryEnd}
      />
    </div>
  );
};
